import React from 'react';
import { showDetails } from '../../../utils/helpers/module/moduleComponentHelper';
import IconComponent from '../../common/component/IconComponent';

export const cellDetailIconComponent = (props: any) => {
  return (
    <div>
      <IconComponent
        icon={props.icon}
        event={() => showDetails(props.row, props.history, props.module)}
        imgStyles={{ cursor: 'pointer' }}
        divStyles={{ marginTop: '4px' }}
        id={props.id}
      />
    </div>
  );
};

export const cellZoomIconComponent = (props: any) => {
    return (
      <div>
        <IconComponent
          icon={props.icon}
          event={() =>
            props.row.row.original.geometry !== undefined &&
              props.zoomToPointTrigger({ x: props.row.row.original.geometry.x, y: props.row.row.original.geometry.y })
          }
          imgStyles={{ cursor: 'pointer' }}
          divStyles={{ marginTop: '4px' }}
          id={props.id}
        />
      </div>
    );
};
